module.exports = __webpack_public_path__ + "static/media/LevelUpgradePlatinum.d12bc8e3.png";